import React from 'react'
import {
ContainerFluid,HeadingText,Container,ParagraphText,ContainerFluidB,ContainerFluidC
} from './SectionAComponent.style';
function SectionAComponent() {
  return (
    <div>
      <ContainerFluid>
        <br/><br/>
        <Container>
          <div className='row'>
            <div className='col s11'>
              <ParagraphText>
                <b>
                PLEASE READ THE TERMS CAREFULLY BECAUSE THEY CONSTITUTE A LEGALLY BINDING AGREEMENT 
                BETWEEN YOU AND YALLA TECHNOLOGIES LIMITED
                </b> 
              </ParagraphText>
              
              <ParagraphText>
                <b>INTRODUCTION</b> <br/>
                Yalla Technologies Limited (herein referred to as “ Yalla Technologies ”) provides its content on its websites and 
                mobile applications (the “Platforms”) subject to the following terms and conditions (the “Terms”). We may periodically 
                change the Terms without prior notice, so please check back from time to time. By accessing and using this Site, you 
                agree to these Terms. Please read the privacy policy carefully before accessing our platform or using our services. 
              </ParagraphText>
              <ParagraphText>
                By your use of the Service, you agree to comply with all of the terms and conditions set out in this Agreement. 
                “Me” and “Your” refer to the person accessing our using the services. “Our”, “Us” or “We” refer to 
                Yalla and it successors, affiliates and assignees.
              </ParagraphText>
            </div>
          </div>
          
        </Container>
      </ContainerFluid>
      <ContainerFluidB>
      <br/><br/>
        <Container>
          <div className='row'>
            <div className='col s11'>
              
              <ParagraphText>
                <b>REQUIREMENTS TO ACCESS OR USE SERVICES</b> <br/><br/>
                In order to access or use our services, you must:<br/>
                (i) be a Nigerian citizen (either by birth, naturalisation or registration)<br/>
                (ii) agree to these terms of service<br/>
                (iii) register on our website<br/>
                (iv) have an bank account with a Nigerian financial institution<br/>
                (v) provide all necessary information requested by us and other information we may request from time to time
                (collectively referred to as “ User Information)<br/>
              </ParagraphText>
              <ParagraphText>
                By using our Services and providing us with your information, you automatically authorize us to obtain either directly 
                or indirectly through our third-party service providers and without any time limit or the requirement to pay any fees, 
                information about you and your Bank Account from the financial institution holding your bank account and other third-
                party websites and databases as necessary to provide the Services to you.
              </ParagraphText>
              <ParagraphText>
                Further, all documents and information received by Yalla Technologies, our officers, employees or agents, which are 
                not published or publicized shall be kept confidential and not disclosed to third parties or the public. However, this 
                restriction shall not be applicable where any information disclosed is by reason of being required by order of a Court 
                of competent jurisdiction, by a Governmental or Regulatory authority in Nigeria. This covenant shall be applicable even 
                after the Termination of these terms of use.
              </ParagraphText>
              <ParagraphText>
                For the purpose of authorization, you grant Yalla Technologies and our third party service providers a limited Power of 
                Attorney, to be your lawful Power of Attorney and agent, with the full power of substitution and resubstitution for you 
                in your name, place and stead in any and all capacities, to access third-party websites, servers, and documents; 
                retrieve information; and use your User Information, all as described above, with the full power and authority to do and 
                perform each and every act and thing requisite and necessary to be done in connection with such activities, as fully to 
                all intents and purposes as you might or could do in person. You agree that when Yalla Technologies and our third party 
                providers represent your stead as described above, we act as your agent and not the agent or on behalf of the third 
                party. You further agree that other third parties shall be entitled to rely on the foregoing authorization, agency, and 
                power of attorney granted by you.
              </ParagraphText>
              <ParagraphText>
                We make no effort to review information obtained from the financial institution holding your Bank Account and other 
                third-party websites and databases for any purpose, including, but not limited to, accuracy, legality, or non-infringement. 
                As between Yalla Technologies and our third-party service providers, Yalla Technologies owns your confidential User 
                Information.
              </ParagraphText>
              <ParagraphText>
                By your use of the Service, you agree to comply with all of the terms and conditions set out in this Agreement. 
                “Me” and “Your” refer to the person accessing our using the services. “Our”, “Us” or “We” refer to 
                Yalla and it successors, affiliates and assignees.
              </ParagraphText>
            </div>
          </div>
          
        </Container>
      </ContainerFluidB>
      <ContainerFluidB>
      <br/><br/>
        <Container>
          <div className='row'>
            <div className='col s11'>
              
              <ParagraphText>
                <b>POWER OF ATTORNEY</b> <br/><br/>
                Our authority will include the ability to manage your User Account utilising your selected Yalla Technologies investment 
                model such as manage cash balances within your account, purchase and sale securities, peer-peer trading, equity 
                funding, among others.
              </ParagraphText>
              <ParagraphText>
                You accept that:<br/>

                All User assets/investments are held with a licensed custodian for safekeeping inorder to limit the risk of their 
                misappropriation, misuse, loss and/theft and in accordance with the Applicable Laws;
              </ParagraphText>
              <ParagraphText>
                You agree and understand that your use of Yalla Technologies is for educational purposes alone and it is not intended 
                to provide legal, financial planning and tax advise and that you are advised to consider additional asset classes, 
                strategies and investment options to supplement your overall plan. We are not responsible for ensuring your debit card 
                has sufficient funds for your needs and transactions. Consider consultation with your Tax Advisers regarding any tax 
                consequences relating to your Account.
                <br/><br/>
                Decisions made by Users based on the information on our platform are solely the responsibility of the User.
              </ParagraphText>
              
              
            </div>
          </div>
          
        </Container>
      </ContainerFluidB>
      <ContainerFluidB>
        <br/><br/>
        <Container>
          <div className='row'>
            <div className='col s11'>
            <ParagraphText>
                <b>FEES AND EXPENSES </b> <br/><br/>
                There are no transaction fees/ monthly fees for the services we render. You agree that you may incur certain other 
                charges imposed by your financial institutions such as transfer fees, etc, and you understand that these fees are not 
                included in the fees you pay to Yalla Technologies. 
                We reserve the right to charge fees for our services in the future. 
                Such changes will require you being notified through email, our website or any other means required by Applicable 
                Laws. Your continuous use of our services after such notification shall require you to pay all applicable fees for our 
                services. 
              </ParagraphText>
            </div>
          </div>
        </Container>
      </ContainerFluidB>

      <ContainerFluidB>
        <br/><br/>
        <Container>
          <div className='row'>
            <div className='col s11'>
            <ParagraphText>
                <b>DISCLAIMER  </b> <br/><br/>
                You accept and understand that we provide services for other users and that we may take investment actions on 
                behalf of such other users that differs from the investment actions taken on behalf of your own account. You further 
                agree and understand that there may be loss or depreciation in the value of any investment and in any of the assets 
                due to the fluctuations of the market values and accordingly, the value of assets in your User Account may change and 
                decrease. You accept that we never made any guarantee either orally or written, that your investment objectives will 
                be met or that the value of any User Account assets will not decline. 
                <br/><br/>
                Further, all documents and information received by Yalla Technologies, our officers, employees or agents, which are 
                not published or publicized shall be kept confidential and not disclosed to third parties or the public. However, this 
                restriction shall not be applicable where any information disclosed is by reason of being required by order of a Court 
                of competent jurisdiction, by a Governmental or Regulatory authority in Nigeria. This covenant shall be applicable even 
                after the Termination of these terms of use.
              </ParagraphText>
            </div>
          </div>
        </Container>
      </ContainerFluidB>

      <ContainerFluidC className=''>
        <Container>
          <div className='row mt-100'>
            <div className='col s12 m12 l7'>
              <br/><br/><br/>
            </div>
          </div>
        </Container>
      </ContainerFluidC>
    </div>
  )
}

export default SectionAComponent